module.exports = __webpack_public_path__ + "static/media/real-estate.7d48c45d.png";